export const ServerConfiguartions = [
  {
    id: 'propertyLevel',
    name: 'Property Level',
  },
  {
    id: 'roomLevel',
    name: 'Room Level',
  },
];
